import React from "react";
import { Link } from "react-router-dom";

const Privacy: React.FC = () => {
  return (
    <div className="card mb-4">
      <div className="card-body">
        <h2>Privacy Policy</h2>
        <p className="text-muted">Last updated: {new Date().getFullYear()}</p>

        <p>
          TripSplitter is committed to protecting your privacy. This policy explains what personal data we collect, how we use it, and the choices you have.
        </p>

        <h5>Data we collect</h5>
        <p className="text-muted">We collect the information you provide when you create an account or participate in a trip: your name and email address. When you add participants, their email addresses are stored so they can be invited to view trips. Expense data (description, amount, participants) is stored to calculate balances.</p>

        <h5>Authentication</h5>
        <p className="text-muted">Authentication is handled by Auth0. We do not store your Auth0 password. We use the authenticated email and name to identify you within TripSplitter.</p>

        <h5>Email</h5>
        <p className="text-muted">When you invite someone or use the "Notify" features, TripSplitter will send an email to the provided address. Emails are sent via the configured SMTP server. In development, emails may be written to a local folder instead of being sent.</p>

        <h5>Data retention and deletion</h5>
        <p className="text-muted">You can delete trips to remove their associated data. If you require account deletion or removal of personal data, contact the app maintainer and we will assist with removal.</p>

        <h5>Security</h5>
        <p className="text-muted">We use standard security practices to protect data (HTTPS, server-side validation). Sensitive configuration like SMTP credentials should be stored in environment variables and not in source control.</p>

        <h5>Third parties</h5>
        <p className="text-muted">We rely on third-party services such as Auth0 for authentication and an SMTP provider for sending email. Please review their privacy policies for details.</p>

        <h5>Contact</h5>
        <p className="text-muted">For privacy requests or questions, please open an issue in the repository or contact the app owner.</p>

        <Link to="/" className="btn btn-secondary mt-3">Back to Trips</Link>
      </div>
    </div>
  );
};

export default Privacy;
